import React, { lazy } from 'react';
import { Lock } from 'lucide-react';
export function MercadoPagoBadge() {
  return <div className="bg-white py-3 px-4" data-id="element-163">
      <div className="max-w-3xl mx-auto flex items-center justify-center gap-2" data-id="element-164">
        <Lock size={14} className="text-gray-500" data-id="element-165" />
        <span className="text-gray-600 text-xs md:text-sm font-medium" data-id="element-166">
          Pago 100% seguro procesado por
        </span>
        <img src="https://cdn.magicpatterns.com/uploads/tqRHKX5pSwNtYdh9KeGCNA/pasted-image.png" alt="Mercado Pago" width={100} height={30} loading="lazy" className="h-5 w-auto object-contain" data-id="element-167" />
        <span className="text-gray-400 text-[10px] hidden sm:inline" data-id="element-168">
          · Encriptación SSL
        </span>
      </div>
    </div>;
}